module.exports = __webpack_public_path__ + "static/agile-docs-35922a069cca6ab852aa2c45e6cd2201.png";